module.exports = __webpack_public_path__ + "img/second@2x.42ff76e5.png";